import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEdit = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            d="M21.424 5.87 19.91 7.382 16.617 4.09l1.514-1.514a.69.69 0 0 1 .972 0l2.321 2.32a.69.69 0 0 1 0 .974M6.761 20.531a.7.7 0 0 1-.357.19l-3.853.727.729-3.854a.67.67 0 0 1 .188-.356L15.645 5.06l3.293 3.295ZM22.397 3.924l-2.322-2.322a2.067 2.067 0 0 0-2.916 0L2.496 16.265a2.04 2.04 0 0 0-.568 1.077l-.916 4.842a.69.69 0 0 0 .803.803l4.846-.915c.41-.078.783-.276 1.073-.569L22.397 6.842a2.066 2.066 0 0 0 0-2.918"
        />
    </svg>
);
export default SvgEdit;
